import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface ArtPieceDeleteConfirmData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-art-piece-delete-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content class="dialog-body">
      <p>{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button mat-dialog-close type="button">Cancel</button>
      <button mat-flat-button color="warn" [mat-dialog-close]="true" type="button">
        Delete
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .dialog-body {
        padding-top: 0;
      }
    `,
  ],
})
export class ArtPieceDeleteConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ArtPieceDeleteConfirmData) {}
}
